import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import store from './store/store'

import '@fortawesome/fontawesome-free/css/all.css'
//import '@fortawesome/fontawesome-free/js/all.js'
import vSelect from 'vue-select'
// router setup
import router from './routes/router';
// plugin setup
Vue.use(DashboardPlugin);
Vue.component('v-select', vSelect)
import Snotify from 'vue-snotify';
import "vue-snotify/styles/material.css";
Vue.use(Snotify);

/* Vue Overlay library for loading spiner */
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXtfeXVWR2JYWEx/WUI=');

Vue.component('loading', Loading);

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('superbos_admin_access_token')
  // If logged in, or going to the Login page.
  if (token || to.name === 'Login') {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      var base64Url = localStorage.getItem('superbos_admin_access_token').split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      let payload = JSON.parse(jsonPayload);
      let permissions = payload.scopes;
      if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!to.meta.permission.every(i => permissions.includes(i)) && to.meta.permission) {
          next({ name: 'notfound' })
        } else {
          next()
        }
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    // Not logged in, redirect to login.
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next({ name: 'Login' })
    } else {
      next()
    }
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  beforeCreate() {
    Vue.$snotify = this.$snotify;
  }
});
